import reactCSS from 'reactcss';
import {
  headingXl,
  headingS,
  content,
  smallprint,
} from '@ux/type-size';
import cssSides, { Side } from '@team-griffin/css-sides';
import longhand from '@team-griffin/css-longhand';
import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
  isMinSm,
  isMinLg,
}) => {
  const {
    spacing,
    palette,
    typography,
  } = theme;

  return reactCSS({
    default: {
      panel: {
        overflow: 'hidden',
      },
      body: {
        ...cssSides('padding', Side.A, gu2px(3, spacing)),
        ...content(typography),
      },
      paragraph: {
        marginTop: 0,
        marginBottom: gu2px(2, spacing),
      },
      productPrice: {
        marginTop: gu2px(0.5, spacing),
      },
      price: {
        color: palette.primary,
        ...headingXl(typography),
      },
      priceTerm: {
        ...headingS(typography),
      },
      actions: {
        marginTop: gu2px(1, spacing),
      },
      buttonText: {
        whiteSpace: 'nowrap',
      },
      legalText: {
        marginTop: gu2px(1, spacing),
        ...smallprint(typography),
        color: palette.grey06,
      },
      availability: {
        display: 'flex',
        justifyContent: 'flex-end',
      },
      icon: {
        width: gu2px(3, spacing),
        height: gu2px(3, spacing),
        marginLeft: gu2px(1, spacing),
      },
    },

    isMinSm: {
      body: {
        display: 'flex',
      },
      cta: {
        flex: 1,
        paddingLeft: gu2px(2, spacing),
        marginLeft: gu2px(2, spacing),
        textAlign: 'right',
        ...longhand('borderLeft', {
          width: 1,
          color: palette.grey10,
          style: 'solid',
        }),
      },
      productPrice: {
        whiteSpace: 'nowrap',
      },
    },

    isMinLg: {
      body: {
        ...cssSides('padding', Side.A, gu2px(4, spacing)),
      },
    },
  }, [
    { isMinSm },
    { isMinLg },
  ]);
};
